import React, { InputHTMLAttributes } from 'react';

import styled from 'styled-components';

const Wrapper = styled.div``;

const Circle = styled.div<{ $size: number }>`
  position: absolute;
  width: ${(props) => `${props.$size}px`};
  height: ${(props) => `${props.$size}px`};
  border-radius: 100%;
  background-color: #ffffff;
  left: 3px;
  /* transition: transform 0.2s ease-in-out; */
  transition: left 0.2s ease-in-out;
`;

const Track = styled.label<{ $width: number; $height: number }>`
  position: relative;
  display: flex;
  align-items: center;
  padding: 3px;
  width: ${(props) => `${props.$width}px`};
  height: ${(props) => `${props.$height}px`};
  border-radius: 20px;
  background-color: ${(props) => props.theme.ui.button.disabledBgColor};
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
`;

const Text = styled.span<{ $width: number }>`
  font-size: 13px;
  position: absolute;
  color: ${(props) => props.theme.global.whiteTextColor};
  width: ${(props) => `${props.$width}px`};
  /* display: flex;
  justify-content: center; */
  text-align: center;
`;

const TrueText = styled(Text)`
  display: none;
`;
const FalseText = styled(Text)`
  right: 3px;
`;

const Input = styled.input<{ $circleLeft: number }>`
  position: absolute;
  width: 0;
  height: 0;
  opacity: 0;
  margin: 0;
  padding: 0;

  &:checked + ${Track} {
    background-color: ${(props) => props.theme.global.mainColor};

    ${Circle} {
      left: ${(props) => `${props.$circleLeft}px`};
    }
    ${TrueText} {
      display: block;
    }
    ${FalseText} {
      display: none;
    }
  }
`;

interface ToggleCheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  id: string;
  width?: number;
  height?: number;
  circleSize?: number;
  text?: [string, string];
}

const ToggleCheckbox = React.forwardRef(
  (
    { id, width = 58, height = 32, circleSize = 26, text, ...rest }: ToggleCheckboxProps,
    ref: React.ForwardedRef<HTMLInputElement>
  ) => {
    return (
      <Wrapper>
        <Input ref={ref} id={id} type="checkbox" $circleLeft={width - circleSize - 3} {...rest} />
        <Track htmlFor={id} $width={width} $height={height}>
          <Circle $size={circleSize}></Circle>
          {text && (
            <>
              <TrueText $width={width - circleSize - 3}>{text[0]}</TrueText>
              <FalseText $width={width - circleSize - 3}>{text[1]}</FalseText>
            </>
          )}
        </Track>
      </Wrapper>
    );
  }
);

export default ToggleCheckbox;
